import styled from 'styled-components';
import { maxWidth, retina } from 'Utils/utilsStyle';

const Wrapper = styled.div`
  overflow: hidden;
  .profile-left{
    display:flex;
    flex-direction:column;
    justify-items: center;
    position:relative;
    &:after {
      content: "";
      width: 1px;
      height: 92%;
      position: absolute;
      right: 0px;
      top: 0px;
      background-color: #F5F1EA;
    }
    .percentage-box{
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-left: 80%;
      margin-bottom: -35px;
    }
    .image-box{
      width: 250px;
      height:250px;
      border-radius:50%;
      margin: 0 auto 0 auto;
       @media all and (max-width: ${maxWidth}) , ${retina} {
        width: 160px;
        height: 160px;
       }
    }
    .badge-container {
      margin-top: -20px;
      margin-bottom: 10px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        margin-top: -15px;
      }
      .disc-box {
        height: 35px;
        width: 35px;
        border-radius:50%;
        margin-left: 20%;
        margin-top: -5px;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          height: 20px;
          width: 20px;
        }
      }
      .badge-box{
        width: 150px;
        height: 20px;
        box-shadow: 0px 0px 5px rgb(0 0 0 / 10%);
        margin-left: 4%;
      }
    }
    .title-box{
      width: 70%;
      height: 30px;
      border-radius:25px;
      margin: 0 auto;
      margin-bottom:10px;
      + .title-box{
        width: 55%;
      }
    }
    .title-small-box{
      border-radius:25px;
      margin: 5px auto 5px auto;
      width: 40%;
      height:18px;
    }
    .btn-box{
      border-radius:25px;
      margin: 30px auto;
      width: 90px;
      height:40px;
    }
  }
  .skeleton-box {
    height: 20px;
    border-radius: 25px;
    width: 50px;
  }
  .wrapper-div {
    text-align: center;
    position: relative;
    margin-bottom: 30px;
  }
`;

const SinglePersonCardSkeleton = function SinglePersonCardSkeleton() {
  return (
    <Wrapper>
      <div className="profile-left">
        <span className="skeleton-box percentage-box" />
        <div className="wrapper-div">
          <span className="skeleton-box image-box" />
          <div className="badge-container">
            <span className="skeleton-box badge-box" />
          </div>
        </div>
        <span className="skeleton-box title-box" />
        <span className="skeleton-box title-box" />
        <div className="designation-box" />
        <span className="skeleton-box title-small-box" />
      </div>
    </Wrapper>
  );
};

export default SinglePersonCardSkeleton;
